export default "__VITE_ASSET__BKIxRYj4__"